export default __webpack_public_path__ + "static/media/IL.365b9313.ico";